module.exports = __webpack_public_path__ + "static/img/list-img1.763dcc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img1.png
// module id = bc5a
// module chunks = 0